import React, { useState } from "react";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { getStoredRef } from "../lib/referral";
import { toast } from "sonner";

export function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const u = await login(form.email, form.password);
      toast.success(`Bentornato, ${u.name}`);
      nav(u.role === "admin" ? "/admin" : "/");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore login");
    } finally { setLoading(false); }
  };
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="label-mono text-neon mb-2">// ACCESSO</div>
        <h1 className="font-display text-4xl mb-8">ENTRA<br/>NEL CIRCUITO</h1>
        <form onSubmit={submit} className="space-y-6 card-dark p-8">
          <div>
            <div className="label-mono mb-1">EMAIL</div>
            <input required type="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} className="input-dark" data-testid="login-email"/>
          </div>
          <div>
            <div className="label-mono mb-1">PASSWORD</div>
            <input required type="password" value={form.password} onChange={e=>setForm({...form,password:e.target.value})} className="input-dark" data-testid="login-password"/>
          </div>
          <button disabled={loading} className="btn-primary w-full" data-testid="login-submit">{loading?"...":"ENTRA"}</button>
          <div className="text-center text-sm text-neutral-500">
            Non hai account? <Link to="/register" className="text-neon hover:text-glow-neon">Registrati</Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [form, setForm] = useState({ email: "", password: "", name: "", referral_code: params.get("ref") || getStoredRef() });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      await register(form);
      toast.success("Benvenuto nel circuito");
      nav("/affiliazione");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore registrazione");
    } finally { setLoading(false); }
  };
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="label-mono text-alert mb-2">// NEW_ENTRY</div>
        <h1 className="font-display text-4xl mb-8">REGISTRATI</h1>
        <form onSubmit={submit} className="space-y-6 card-dark p-8">
          <div>
            <div className="label-mono mb-1">NOME</div>
            <input required value={form.name} onChange={e=>setForm({...form,name:e.target.value})} className="input-dark" data-testid="reg-name"/>
          </div>
          <div>
            <div className="label-mono mb-1">EMAIL</div>
            <input required type="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} className="input-dark" data-testid="reg-email"/>
          </div>
          <div>
            <div className="label-mono mb-1">PASSWORD (min 6)</div>
            <input required type="password" minLength={6} value={form.password} onChange={e=>setForm({...form,password:e.target.value})} className="input-dark" data-testid="reg-password"/>
          </div>
          <div>
            <div className="label-mono mb-1">CODICE REFERRAL (opz.)</div>
            <input value={form.referral_code} onChange={e=>setForm({...form,referral_code:e.target.value.toUpperCase()})} className="input-dark font-mono" data-testid="reg-ref"/>
          </div>
          <button disabled={loading} className="btn-primary w-full" data-testid="reg-submit">{loading?"...":"CREA ACCOUNT"}</button>
          <div className="text-center text-sm text-neutral-500">
            Già registrato? <Link to="/login" className="text-neon hover:text-glow-neon">Login</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
